export default "__VITE_ASSET__Bgg8NoZ$__"